import { render } from "./Part2.vue?vue&type=template&id=308f5dc0&scoped=true"
import script from "./Part2.vue?vue&type=script&lang=js"
export * from "./Part2.vue?vue&type=script&lang=js"

import "./Part2.vue?vue&type=style&index=0&id=308f5dc0&lang=less&scoped=true"

import exportComponent from "/var/www/tz-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-308f5dc0"]])

export default __exports__